export enum CountryOfRegistration {
  CZ = 1,
  SK = 2,
  PL = 3,
}
